
import {
  defineComponent
} from 'vue';

export default defineComponent({
  name: 'CompositionComponent',
  props: {
    name: {
      type: String,
      required: true
    },
    summary: {
      type: String
    },
    avatarUrl: {
      type: URL
    },
    stackoverflowRep: {
      type: Number
    }
  },
  setup() {
    return {};
  },
});
